export default __webpack_public_path__ + "static/media/backpack.fb8eda58.png";